<template>
<div>
	<search-bar v-model="employeeSearchTerms" placeholder="Search Employees..." full-width="true"></search-bar>

	<div class="p-2 pb-0">
		<field v-model="employeeListFilters"
			:params="{type:'checklist',options:[
				{text: 'Hide salaried employees',value:'hide-salaried-employees'},
				{text: 'Show only unscheduled',value:'only-unscheduled'}
			]}">
		</field>
	</div>

	<div v-if="employeePickerMutatedUsers.length > 0"
		class="list-group">

		<selector-list-employee-item v-for="user in employeePickerMutatedUsers"
			:user="user"
			:full-element-clickable="true"
			:selected-date="selectedDate"
			:compiled-hours="calcHoursScheduled(eventsList,user,'user_id',selectedDate)"
			v-on:addClick="selectUser(user)">		
		</selector-list-employee-item>
	</div>
	<spinner v-else :inline="true"></spinner>
</div>
</template>
<script>
import SearchBar from "@/components/SearchBar"
import Field from "@/components/Field"
import Spinner from "@/components/Spinner"

import SelectorListEmployeeItem from "@/components/schedule/SelectorListEmployeeItem"

import ScheduleMixins from "@/mixins/ScheduleMixins.js"

export default {
	name: "EventEmployeeEntityPicker",
	components: {
		SearchBar,
		Field,
		Spinner,
		SelectorListEmployeeItem
	},
	mixins: [ScheduleMixins],
	props: ["selectedDate","eventsList"],
	data() {
		return {
			employeeListFilters: [],
		}
	},
	computed: {
	},
	methods: {
		selectUser(user) {
			this.$emit("userSelected",user)
		}
	},
	created() {
		let vm = this
		let userParams = {
			fields: ["id","slug","first_name","last_name"],
			include: ["EmployeeSetting"]
		}

		this.getJSON("User/get",userParams).then(response => {
			if (response.success)
				vm.users = vm.cloneObj(response.data)
		})
	}
}
</script>